module.exports = __webpack_public_path__ + "img/falkland-islands.62ec11a4.png";